// Collection paging: the "Show" limiter, "Load more" and the "Displaying X out of Y" line.
//
// Plain collection pages get their page size from the server (?view=24 picks collection.24).
// Cloud Search filter pages (/a/search/<collection>?filter_...) ignore ?view and always serve
// fixed-size pages, so the page size is applied here instead: pages are fetched through the
// next-page link and anything beyond the chosen size is kept hidden until "Load more".
// Both cases go through the same code; on a plain page one fetch is exactly one page.
var collectionPaging = (function () {
  var loading = false;

  function isCloudSearchPage() {
    return document.getElementById("cloudsearch-data") !== null;
  }

  function chosenLimit() {
    var view = new URLSearchParams(location.search).get("view");
    if (view === "all") return Infinity;
    var n = parseInt(view, 10);
    return n > 0 ? n : parseInt($("select[name=limiter] option:first").val(), 10) || 20;
  }

  // Theme previews of Cloud Search pages only render when cs_theme is on the URL.
  function withPreviewTheme(url) {
    var csTheme = new URLSearchParams(location.search).get("cs_theme");
    if (!url || !csTheme) return url;
    var u = new URL(url, location.href);
    if (!u.searchParams.has("cs_theme")) u.searchParams.set("cs_theme", csTheme);
    return u.pathname + u.search;
  }

  function items() {
    return $(".products-grid > li.product");
  }

  function nextUrl() {
    return $("[data-next-link]").val();
  }

  function fetchNextPage() {
    return $.ajax({ url: withPreviewTheme(nextUrl()), type: "GET", dataType: "html" }).then(function (html) {
      var $response = $(html);
      $(".products-grid").append($response.find(".products-grid").html());
      $("[data-next-link]").val($response.find("[data-next-link]").val() || "");
    });
  }

  function render(target) {
    var $items = items();
    $items.slice(0, target).show();
    $items.slice(target).hide();
    $("[data-products-shown]").text(Math.min(target, $items.length));
    var more = $items.length > target || !!nextUrl();
    $(".load-more_wrap").attr("hidden", !more);
  }

  function setLoading(on) {
    loading = on;
    var $btn = $(".js-load-more");
    $btn.prop("disabled", on);
    $btn.find("[load-more-text]").toggleClass("hide", on);
    $btn.find("[loader]").toggleClass("hide", !on);
  }

  // Fetch pages until `target` products are loaded (or there are no more), then show exactly `target`.
  function showUpTo(target) {
    if (loading) return;
    setLoading(true);
    (function step() {
      if (items().length >= target || !nextUrl()) {
        setLoading(false);
        render(target);
        return;
      }
      fetchNextPage().then(step, function () {
        setLoading(false);
        render(target);
      });
    })();
  }

  function visibleCount() {
    return items().filter(function () {
      return this.style.display !== "none";
    }).length;
  }

  // Called by the theme's limiter handler; returns true when it handled the change.
  function applyLimit(value) {
    if (!isCloudSearchPage()) return false;
    var url = new URL(location.href);
    url.searchParams.set("view", value);
    history.replaceState(history.state, "", url);
    $("select[name=limiter]").val(value);
    showUpTo(chosenLimit());
    return true;
  }

  $(document).on("click", ".js-load-more", function (e) {
    e.preventDefault();
    showUpTo(visibleCount() + chosenLimit());
  });

  $(function () {
    if (!isCloudSearchPage()) return;
    var view = new URLSearchParams(location.search).get("view");
    if (view && $("select[name=limiter] option[value='" + view + "']").length) {
      $("select[name=limiter]").val(view);
    }
    showUpTo(chosenLimit());
  });

  return { applyLimit: applyLimit };
})();
